import React from "react";
import ColorItem from "./ColorItem";
const ColorGroup = ({ colors = [], onColorSelect, isColorActive, isPremium = false, title = null,wainsCoatComponent= false }) => {
	if (!colors || colors.length === 0) {
		return null;
	}
	return (
		<>
			<div className={`color-group ${isPremium ? "premium-group" : ""}`}>
				{colors.map((color, index) => (
					<ColorItem
						key={`${color?.id || color?.hex_value}-${index}`}
						color={color}
						isActive={isColorActive(color)}
						onClick={() => onColorSelect(color)}
						isPremium={isPremium}
						index={`${isPremium ? "premium" : "standard"}-${index}`}
						wainsCoatComponent = {wainsCoatComponent}
					/>
				))}
			</div>
		</>
	);
};
export default React.memo(ColorGroup);
